<template>
  <div class="unit-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Informações da unidade</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-1" v-if="unitForm.is_current_default">
          <b-col>
            <div class="alert text-left alert-warning" role="alert">
              <p class="mb-0"><i class="far fa-home mr-2"></i>Unidade principal da conta</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Dados da unidade
              </div>
              <div class="content">
                <b-row class="mb-2" v-if="unitForm.client != null">
                  <b-col cols="12" md="4">
                    <label class="cj-label">Cliente</label>
                    <b-form-input type="text" v-model="unitForm.client.name" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col cols="12">
                    <label class="cj-label mb-2">Os campos a seguir são exibidos para os pacientes nas mensagens de lembretes, agenda on-line e documentos dos pacientes que esta Unidade estiver associada.</label>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Nome Fantasia / Nome completo</label>
                    <b-form-input type="text" v-model="unitForm.display_name" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">CPF / CNPJ</label>
                    <b-form-input type="tel" v-model="unitForm.display_document" :disabled="true" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Telefone comercial</label>
                    <b-form-input type="tel" v-model="unitForm.display_telephone" :disabled="true" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Celular / Whatsapp comercial</label>
                    <b-form-input type="text" v-model="unitForm.display_cellphone" :disabled="true" v-mask="'(##) #####-####'"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">E-mail comercial</label>
                    <b-form-input type="email" v-model="unitForm.display_email" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col></b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col cols="12">
                    <hr>
                    <p>Endereço</p>
                  </b-col>
                  <b-col>
                    <label class="cj-label">CEP</label>
                    <b-form-input type="tel" v-model="unitForm.display_address.zip_code" v-mask="'#####-###'" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col cols="8">
                    <label class="cj-label">Endereço</label>
                    <b-form-input type="text" v-model="unitForm.display_address.address" ref="display_address" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Número</label>
                    <b-form-input type="tel" v-model="unitForm.display_address.number" ref="display_number" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Complemento</label>
                    <b-form-input type="text" v-model="unitForm.display_address.complement" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Bairro</label>
                    <b-form-input type="text" v-model="unitForm.display_address.neighborhood" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Cidade</label>
                    <b-form-input type="text" v-model="unitForm.display_address.city" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Estado</label>
                    <b-form-input type="text" v-model="unitForm.display_address.state" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">Dados Fiscais e Meio de Pagamento Integrado</p>
                  <div class="pretty p-switch p-fill" v-if="unitForm.zoop_seller_id == null && !unitForm.is_current_tax_info_enabled">
                    <input type="checkbox" v-model="unitForm.tax_info_enabled" :disabled="true" />
                    <div class="state p-success">
                      <label></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content" v-if="unitForm.tax_info_enabled">
                <b-row class="mb-2">
                  <b-col cols="12">
                    <label class="cj-label mb-2">Os campos a seguir serão utilizado para emissão de nota fiscal e habilitar o recebimento pelos meios de pagamento integrados.</label>
                  </b-col>
                  <b-col cols="12" md="4">
                    <label class="cj-label">Tipo (não poderá ser alterado)</label>
                    <multiselect v-model="unitForm.type" :options="sellerTypeOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo" :disabled="true"></multiselect>
                  </b-col>
                </b-row>
                <template v-if="unitForm.type != null">
                  <b-row>
                    <b-col cols="12">
                      <hr>
                      <p>Informações Fiscais</p>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="unitForm.type.value == 'pj'">
                    <b-col>
                      <label class="cj-label">Razão social</label>
                      <b-form-input type="text" v-model="unitForm.company_name" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Nome fantasia</label>
                      <b-form-input type="text" v-model="unitForm.company_fantasy_name" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CNPJ (não poderá ser alterado)</label>
                      <b-form-input type="tel" v-model="unitForm.company_document" :disabled="true" autocomplete="off" v-mask="['##.###.###/####-##']"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-else>
                    <b-col>
                      <label class="cj-label">Nome completo</label>
                      <b-form-input type="text" v-model="unitForm.name" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF (não poderá ser alterado)</label>
                      <b-form-input type="tel" v-model="unitForm.document" :disabled="true" autocomplete="off" v-mask="['###.###.###-##']"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Data de nascimento</label>
                      <date-picker name="birthday" v-model="unitForm.birthday" :disabled="true" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off"></date-picker>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">E-mail (será o usuário de acesso na plataforma de pagamento e não poderá ser alterado futuramente)</label>
                      <b-form-input type="email" v-model="unitForm.email" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Telefone</label>
                      <b-form-input type="tel" v-model="unitForm.telephone" :disabled="true" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Celular / Whatsapp</label>
                      <b-form-input type="text" v-model="unitForm.cellphone" :disabled="true" v-mask="'(##) #####-####'"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <hr>
                      <p>Endereço</p>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CEP</label>
                      <b-form-input type="tel" v-model="unitForm.address.zip_code" v-mask="'#####-###'" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col cols="8">
                      <label class="cj-label">Endereço</label>
                      <b-form-input type="text" v-model="unitForm.address.address" ref="address" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Número</label>
                      <b-form-input type="tel" v-model="unitForm.address.number" ref="number" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Complemento</label>
                      <b-form-input type="text" v-model="unitForm.address.complement" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Bairro</label>
                      <b-form-input type="text" v-model="unitForm.address.neighborhood" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Cidade</label>
                      <b-form-input type="text" v-model="unitForm.address.city" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Estado</label>
                      <b-form-input type="text" v-model="unitForm.address.state" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="unitForm.type.value == 'pj'">
                    <b-col cols="12" class="mt-2">
                      <hr>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Código coligada (opcional)</label>
                      <b-form-input type="text" v-model="unitForm.affiliation_code" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Código filial (opcional)</label>
                      <b-form-input type="text" v-model="unitForm.branch_code" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col></b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12" class="mt-2">
                      <hr>
                    </b-col>
                    <b-col cols="12" class="mb-2">
                      <table class="table table-responsive table-bordered m-0" style="display: table;">
                        <tbody>
                        <tr>
                          <td>Habilitar Meio de Pagamento Integrado</td>
                          <td class="text-center">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="unitForm.charging_enabled" :disabled="true" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <label class="cj-label">Ao habilitar o meio de pagamento integrado, seus dados serão enviados para a operadora de pagamentos e os dados acima, sinalizados com um cadeado, não poderão ser modificados posteriormente. Os dados também devem corresponder com os dados dos documentos comprovantes que são obrigatórios para o credenciamento.</label>
                    </b-col>
                  </b-row>
                  <template v-if="unitForm.charging_enabled">
                    <b-row class="mb-2">
                      <b-col cols="12" md="6">
                        <label class="cj-label">Categoria do negócio (não poderá ser alterado)</label>
                        <multiselect v-model="unitForm.category" :options="sellerCategoryOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Selecione uma categoria" :disabled="true"></multiselect>
                      </b-col>
                      <b-col>
                        <label class="cj-label">{{unitForm.type.value == 'pj' ? 'Faturamento' : 'Renda'}}</label>
                        <money v-model="unitForm.income" class="form-control mb-2" :disabled="true"></money>
                      </b-col>
                      <b-col v-if="unitForm.type.value == 'pj'">
                        <label class="cj-label">Data de abertura</label>
                        <date-picker name="company_opening_date" v-model="unitForm.company_opening_date" :disabled="true" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off"></date-picker>
                      </b-col>
                      <b-col v-else></b-col>
                    </b-row>
                    <template v-if="unitForm.type.value == 'pj'">
                      <b-row class="mb-2">
                        <b-col cols="12">
                          <hr>
                          <p>Dados do Proprietário</p>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Nome completo</label>
                          <b-form-input type="text" v-model="unitForm.name" :disabled="true" autocomplete="off"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">CPF</label>
                          <b-form-input type="tel" v-model="unitForm.document" :disabled="true" autocomplete="off" v-mask="['###.###.###-##']"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Data de nascimento</label>
                          <date-picker name="birthday" v-model="unitForm.birthday" :disabled="true" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off"></date-picker>
                        </b-col>
                      </b-row>
                    </template>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <hr>
                        <p class="mb-0">Conta bancária para recebimento</p>
                        <label class="cj-label mb-2">Você só pode cadastrar contas bancárias do mesmo titular do CNPJ/CPF</label>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Titular</label>
                        <b-form-input type="text" :value="unitForm.company_name != null ? unitForm.company_name : unitForm.name" :disabled="true"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Banco</label>
                        <multiselect v-model="unitForm.bankAccount.bank" :options="bankOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione um banco" :disabled="true"></multiselect>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Tipo de conta</label>
                        <multiselect v-model="unitForm.bankAccount.type" :options="bankTypeOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de conta" :disabled="true"></multiselect>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Agência (sem DV)</label>
                        <b-form-input type="tel" v-model="unitForm.bankAccount.agency" :disabled="true" autocomplete="off" v-mask="'###########'"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Conta (com DV)</label>
                        <b-form-input type="tel" v-model="unitForm.bankAccount.account" :disabled="true" autocomplete="off" v-mask="'###############'"></b-form-input>
                      </b-col>

                      <b-col cols="12" class="mt-2">
                        <hr>
                        <p class="mb-0">Documentos</p>
                        <label class="cj-label mb-2">Os documentos devem coincidir com os dados informados no campos acima, qualquer divergência pode resultar no não credenciamento junto a operadora dos meios de pagamento</label>
                      </b-col>
                      <b-col cols="12" md="6" v-if="unitForm.type.value == 'pj'">
                        <b-row>
                          <b-col cols="12">
                            <p class="mb-1">Cartão CNPJ/Contrato social</p>
                          </b-col>
                          <b-col cols="12" class="mb-3">
                            <label class="cj-label">Cópia do cartão do CNPJ ou cópia do contrato social da empresa</label>
                            <span v-if="unitForm.documents.cnpj.uploaded" class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                            <span v-else class="d-block document-sent mb-2"><i class="fa fa-exclamation-circle text-warning mr-1"></i>Pendente</span>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-row>
                          <b-col cols="12">
                            <p class="mb-1">Comprovante de atividade</p>
                          </b-col>
                          <b-col cols="12" class="mb-3">
                            <label class="cj-label">Comprovante da atividade exercida (cartão de visita, print do site, nota fiscal de compra de produtos ou prestação de serviços, etc)</label>
                            <span v-if="unitForm.documents.atividade.uploaded" class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                            <span v-else class="d-block document-sent mb-2"><i class="fa fa-exclamation-circle text-warning mr-1"></i>Pendente</span>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-row>
                          <b-col cols="12">
                            <p class="mb-1">Documento de identidade</p>
                          </b-col>
                          <b-col cols="12" class="mb-3">
                            <label class="cj-label">Documento de identidade com foto (RG e CPF ou CNH){{ unitForm.type.value == 'pj' ? ' do proprietário/sócios' : '' }}</label>
                            <span v-if="unitForm.documents.identificacao.uploaded" class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                            <span v-else class="d-block document-sent mb-2"><i class="fa fa-exclamation-circle text-warning mr-1"></i>Pendente</span>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-row>
                          <b-col cols="12">
                            <p class="mb-1">Comprovante de residência</p>
                          </b-col>
                          <b-col cols="12" class="mb-3">
                            <label class="cj-label">Comprovante de residência em {{ unitForm.type.value == 'pj' ? 'nome do proprietário/sócios' : 'seu nome (ou de familiares)' }}</label>
                            <span v-if="unitForm.documents.residencia.uploaded" class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                            <span v-else class="d-block document-sent mb-2"><i class="fa fa-exclamation-circle text-warning mr-1"></i>Pendente</span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Plano atual</label>
                        <b-form-input type="text" :value="unitForm.zoop_plan_id" :disabled="true"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Com antecipação</label>
                        <b-form-input type="text" :value="unitForm.zoop_anticipation_enabled ? 'Sim' : 'Não'" :disabled="true"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Novo plano (opcional)</label>
                        <multiselect v-model="unitForm.zoop_new_plan_id" :options="planOptions" @select="planSelected" track-by="name" label="name" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione um novo plano">
                          <template slot="clear">
                            <div class="multiselect__clear" v-if="unitForm.zoop_new_plan_id != null" @mousedown.prevent.stop="unitForm.zoop_new_plan_id = null"></div>
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Com antecipação</label>
                        <b-form-input type="text" :value="unitForm.zoop_new_plan_id != null ? (unitForm.zoop_new_plan_anticipation_enabled ? 'Sim' : 'Não') : ''" :disabled="true"></b-form-input>
                      </b-col>
                    </b-row>
                  </template>
                </template>
              </div>
              <div class="footer" v-if="unitForm.charging_enabled && canEdit">
                <b-button variant="primary" class="mr-3" @click="saveUnit" :disabled="unitForm.zoop_new_plan_id == null">Salvar</b-button>
              </div>
            </div>
          </b-col>
          <b-col v-if="unitForm.zoop_seller_id != null" cols="12">
            <div class="alert text-center" :class="getStatus(unitForm).class" role="alert">
              <p class="mb-0">{{ getStatus(unitForm).name }}</p>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                Políticas de cancelamento, reagendamento e não comparecimento
              </div>
              <div class="content">
                <b-row>
                  <b-col>
                    <label class="cj-label">Descrição</label>
                    <b-textarea rows="5" v-model="unitForm.policies" :disabled="true"></b-textarea>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                Termos e aceites
              </div>
              <div class="content">
                <b-row>
                  <b-col>
                    <label class="cj-label">Descrição</label>
                    <div v-html="unitForm.terms_and_acceptances"></div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        canSee: true,
        canManage: true,
        canEdit: true,

        enable_affiliate_account: false,

        currentLogo: null,
        logoFile: null,

        share_patients: false,
        share_forms: false,
        enable_digital_prescriptions: false,
        enable_simultaneous_attendances: false,
        enable_professional_notes: false,
        show_whatsapp_options: false,
        enable_coordinator_profile: false,

        sellerTypeOptions: [
          {value: 'pf', name: 'Pessoa física'},
          {value: 'pj', name: 'Pessoa jurídica'}
        ],
        bankOptions: [],
        bankTypeOptions: [
          {value: '0', name: 'Conta corrente'},
          {value: '1', name: 'Poupança'}
        ],
        sellerCategoryOptions: [],

        planOptions: [],

        unitForm: {
          id: null,
          client: null,
          status: 'INCOMPLETE',
          zoop_seller_id: null,
          is_current_default: false,
          is_current_tax_info_enabled: false,
          // is_default: {value: false, name: 'Não'},
          is_default: false,
          display_name: null,
          display_document: null,
          display_telephone: null,
          display_cellphone: null,
          display_email: null,
          tax_info_enabled: false,

          category: null,
          type: null,
          company_document: null,
          company_name: null,
          company_fantasy_name: null,
          company_opening_date: null,
          income: 0,
          name: null,
          document: null,
          email: null,
          birthday: null,
          telephone: null,
          cellphone: null,
          documents: {
            cnpj: {file: null, file_name: null, selected_file: null, uploaded: false},
            atividade: {file: null, file_name: null, selected_file: null, uploaded: false},
            identificacao: {file: null, file_name: null, selected_file: null, uploaded: false},
            residencia: {file: null, file_name: null, selected_file: null, uploaded: false},
          },
          display_address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          affiliation_code: null,
          branch_code: null,
          policies: null,
          terms_and_acceptances: null,
          bankAccount: {
            bank: null,
            type: {value: '0', name: 'Conta corrente'},
            agency: null,
            account: null,
          },
          charging_enabled: false,
          zoop_plan_id: null,
          zoop_anticipation_enabled: false,
          zoop_new_plan_id: null,
          zoop_new_plan_anticipation_enabled: false,
        },

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    mounted () {
      this.canSee = true;
      this.canManage = true;
      this.canEdit = false;

      this.eventBus.$emit('IS_LOADING', true);
      this.api.getUnit(this.$route.params.id).then(res => {
        this.bankOptions = [];
        this.sellerCategoryOptions = [];
        res.data.banks.forEach(bank => {
          this.bankOptions.push({ value: bank.id, name: bank.name });
        });
        res.data.categories.forEach(category => {
          this.sellerCategoryOptions.push({ value: category.id, name: category.name });
        });
        res.data.plans.forEach(plan => {
          this.planOptions.push({ value: plan.id, name: plan.id });
        });

        let unitData = res.data.unit;
        let displayAddress = (unitData.display_address == null) ? {
          id: null,
          zip_code: '',
          address: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          country: 'Brazil'
        } : unitData.display_address;

        let address = (unitData.address == null) ? {
          id: null,
          zip_code: '',
          address: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          country: 'Brazil'
        } : unitData.address;
        let bankAccount = (unitData.latest_bank_account == null) ? {
          bank: null,
          type: {value: '0', name: 'Conta corrente'},
          agency: null,
          account: null,
        } : unitData.latest_bank_account;

        if(unitData.latest_bank_account != null) {
          bankAccount.bank = this.bankOptions.find(g => g.value == unitData.latest_bank_account.bank_id);
          bankAccount.type = this.bankTypeOptions.find(g => g.value == unitData.latest_bank_account.is_savings ? 1 : 0);
        }

        this.unitForm = {
          id: unitData.id,
          client: unitData.client,
          status: unitData.status,
          zoop_seller_id: unitData.zoop_seller_id,
          is_current_default: unitData.is_default,
          // is_default: this.defaultOptions.find(g => g.value == unitData.is_default),
          display_name: unitData.display_name,
          display_document: unitData.display_document,
          display_telephone: unitData.display_telephone,
          display_cellphone: unitData.display_cellphone,
          display_email: unitData.display_email,
          tax_info_enabled: unitData.tax_info_enabled,
          is_current_tax_info_enabled: unitData.tax_info_enabled,

          type: unitData.company_document != null || unitData.document != null ? this.sellerTypeOptions.find(g => g.value == (unitData.company_document == null ? 'pf' : 'pj')) : null,
          category: unitData.zoop_seller_category != null ? this.sellerCategoryOptions.find(g => g.value == unitData.zoop_seller_category) : null,
          company_name: unitData.company_name,
          company_fantasy_name: unitData.company_fantasy_name,
          company_document: unitData.company_document,
          company_opening_date: unitData.company_opening_date != null && this.moment(unitData.company_opening_date).isValid()?this.moment(unitData.company_opening_date).format('DD/MM/YYYY'):'',
          income: unitData.income,
          name: unitData.name,
          document: unitData.document,
          email: unitData.email,
          telephone: unitData.telephone,
          cellphone: unitData.cellphone,
          birthday: unitData.birthday != null && this.moment(unitData.birthday).isValid()?this.moment(unitData.birthday).format('DD/MM/YYYY'):'',
          documents: {
            cnpj: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_company_document_id != null},
            atividade: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_activity_document_id != null},
            identificacao: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_id_document_id != null},
            residencia: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_residence_document_id != null},
          },
          display_address: displayAddress,
          address: address,
          affiliation_code: unitData.affiliation_code,
          branch_code: unitData.branch_code,
          policies: unitData.policies,
          terms_and_acceptances: unitData.terms_and_acceptances,
          bankAccount: bankAccount,
          charging_enabled: unitData.zoop_seller_id != null || unitData.status != 'INCOMPLETE',
          zoop_plan_id: unitData.zoop_plan_id,
          zoop_anticipation_enabled: unitData.zoop_anticipation_enabled,
          zoop_new_plan_id: null,
          zoop_new_plan_anticipation_enabled: false,
        };

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Unit', res);

        this.eventBus.$emit('IS_LOADING', false);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.$router.push({path: '/'});

        this.$swal('Ops...', 'Não conseguimos carregar os dados da unidade! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Unit', err.response);
      });
    },
    methods: {
      saveUnit () {
        let unitData = {
          zoop_plan_id: this.unitForm.zoop_new_plan_id != null ? this.unitForm.zoop_new_plan_id.value : null,
          zoop_anticipation_enabled: this.unitForm.zoop_new_plan_anticipation_enabled
        };
        this.api.saveUnit(this.unit.id, unitData).then(res => {
          if(res.status == 200) {
            this.$swal('Uhull \\o/', 'Os dados da unidade foram atualizados com sucesso!', 'success').then(() => {
              this.$router.go();
            });
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Update Unit', res);
        }).catch(err => {
          let msg = 'Não conseguimos atualizar os dados da unidade! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
            case 422:
              msg = err.response.data.errors.join('\r\n');
              break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Update Unit', err.response);
        });
      },

      planSelected(selectedOption) {
        this.unitForm.zoop_new_plan_anticipation_enabled = selectedOption != null && selectedOption.value.indexOf('_pro') !== -1;
      },

      getStatus(unit) {
        if(unit.status == 'INCOMPLETE') {
          // return {name:'O cadastro está incompleto.', class: 'alert-danger'};
          return {name:'O meio de pagamento integrado não foi cadastrado.', class: 'alert-secondary'};
        }
        else if(unit.status == 'pending') {
          return {name:'O meio de pagamento integrado está em análise.', class: 'alert-warning'};
        }
        else if(unit.status == 'enabled' || unit.status == 'active') {
          return {name:'O meio de pagamento integrado está habilitado.', class: 'alert-success'};
        }
        else if(unit.status == 'deleted') {
          return {name:'O meio de pagamento integrado foi excluído.', class: 'alert-danger'};
        }
        else {
          return {name:'O meio de pagamento integrado está desabilitado.', class: 'alert-secondary'};
        }
      }
    }
  }
</script>

<style lang="scss">
  .unit-form {
    padding: 20px 0;

    .pretty.p-switch .state:before {
      background: #ffffff;
    }

    //.header-info {
    //  p {
    //    margin: 0;
    //  }
    //
    //  .info {
    //
    //  }
    //
    //  .value {
    //    font-size: 32px;
    //    color: $linkWater;
    //  }
    //}

    .box-status {
      font-size: 14px;

      .status-indicator {
        &.complete {
          color: $ufoGreen;
        }
        &.incomplete {
          color: $yellowSea;
        }
      }
    }

    .document-sent {
      font-size: 14px;
    }
  }
</style>
